import React, { useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Features from '../components/Home/Features';
import Stats from '../components/Home/Stats';
import Footer from '../components/Home/Footer';
import NewHero from '../components/Home/NewHero';
import Participate from '../components/Home/Paricipate';
import Testnet from '../components/Home/Testnet';
import Community from '../components/Home/Community';
import Builders from '../components/Home/Builders';
import HydrixNode from '../components/Home/HydrixNode';
import HydrixPay from '../components/Home/Pay';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Very Sans';
    src: url('/assets/fonts/VerySans-LightText.ttf') format('truetype');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Very Sans';
    src: url('/assets/fonts/VerySans-MediumText.ttf') format('truetype');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Very Sans';
    src: url('/assets/fonts/VerySans-BoldText.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Very Sans Headline';
    src: url('/assets/fonts/VerySans-Headline.ttf') format('truetype');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
`;

const PageContainer = styled.div`
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #020611 0%, #050B15 50%, #020611 100%);
  
  &::before {
    content: '';
    position: absolute;
    top: 10%;
    left: -10%;
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(59, 130, 246, 0.08) 0%, transparent 70%);
    pointer-events: none;
    z-index: 1;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 40%;
    right: -10%;
    width: 800px;
    height: 800px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.03) 0%, transparent 70%);
    pointer-events: none;
    z-index: 1;
  }
`;

const GradientOrb1 = styled.div`
  position: absolute;
  top: 60%;
  left: 15%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.05) 0%, transparent 70%);
  pointer-events: none;
  z-index: 1;
`;

const GradientOrb2 = styled.div`
  position: absolute;
  bottom: 10%;
  right: 20%;
  width: 700px;
  height: 700px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.06) 0%, transparent 70%);
  pointer-events: none;
  z-index: 1;
`;

const GradientOrb3 = styled.div`
  position: absolute;
  top: 100px;
  right: 100px;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.05) 0%, transparent 70%);
  pointer-events: none;
  z-index: 20;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

const Home = () => {

    const communityRef = useRef(null);
    const hydrixNodeRef = useRef(null);

  return (
    <>
      <GlobalStyle />
      <PageContainer>
        <GradientOrb1 />
        <GradientOrb2 />
        <GradientOrb3 />
        <ContentWrapper>
          <NewHero communityRef={communityRef} hydrixNodeRef={hydrixNodeRef} />
          <Features />
          <HydrixPay />
          <Stats />
          <div ref={hydrixNodeRef}>
            <HydrixNode />
          </div>
          <Testnet />
          <Builders />
          <div ref={communityRef}>
            <Community />
          </div>
          <Footer />
        </ContentWrapper>
      </PageContainer>
    </>
  );
};

export default Home;